import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';

import BootstrapCol from "ui/BootstrapCol";
import BootstrapRow from "ui/BootstrapRow";
import PanelControlDelete from "../UI/ReactPanelControlDelete";
import ReactTooltip from "react-tooltip";
import ChildAttendanceRow from "./ChildAttendanceRow";
import NavRowComponent from "../Base/NavRowComponent";
import {checkError} from '../DataFunctions/BaseDataFns'

function ChildProgressReviewAttendance2( props, ref )
{
    const [ mode, setMode ] = useState( props.mode ) ;
    const [ attendanceData, setAttendanceData ] = useState( props.attendanceData != null ? props.attendanceData : undefined ) ;
    const [ displayErrors, setDisplayErrors ] = useState( false ) ;

    const formAttendanceRef = useRef( null ) ;
    const tooltipAttendanceRef = useRef( null ) ;

    useEffect( () => {
        setAttendanceData( props.attendanceData ) ;
    }, [ props.attendanceData?.child_attendance_id ]) ;

    useEffect( () => {
        if ( tooltipAttendanceRef.current != null )
        {
            ReactTooltip.rebuild() ;
        }
    }) ;

    // Mirrors the MultiPageForm base behaviour: no child control here exposes an isValid()
    // method, so the form is always considered valid.
    function formIsValid()
    {
        return true ;
    }

    function updateReviewRecords( reviewData )
    {
        $.ajax({
            type: 'PUT',
            url: Globals.APIFolder + '/children/' + reviewData.child_id + '/review',
            data: { review_data: reviewData },
            async: false,
            success: ( data ) => {

                // Call the whole thing off
                if ( checkError( data ))
                {
                    setDirty( false ) ;

                    setMode( props.mode ) ;
                }
            },
            error: function ( jqXHR, textStatus, error ) {
                handleAjaxError( jqXHR, textStatus, error ) ;
            }
        }) ;
    }

    function getFormData()
    {
        var att = formAttendanceRef.current.getFormData() ;

        var data = {} ;

        data.child_attendance_id = attendanceData.child_attendance_id ;
        data.attendance = att ;

        return data ;
    }

    function doSave()
    {
        if ( !formIsValid() )
        {
            setDisplayErrors( true ) ;
        }
        else
        {
            var savedAttendanceData = getFormData() ;

            var reviewData = {} ;

            reviewData.progress_review_id = props.review_data.progress_review_id ;
            reviewData.progress_review_version = props.review_data.progress_review_version ;
            reviewData.child_id = props.child_id ;
            reviewData.attendance_data = savedAttendanceData ;

            updateReviewRecords( reviewData ) ;
        }
    }

    function onLeave()
    {
        if ( props.autoSave == true )
        {
            if ( formIsValid() )
            {
                autoSave() ;
            }
        }
    }

    function autoSave()
    {
        if ( isDirty() )
        {
            doSave() ;
        }
    }

    function isDirty()
    {
        var result = false ;

        if ( formAttendanceRef.current.isDirty() )
        {
            result = true ;
        }

        return result ;
    }

    function setDirty( value )
    {
        formAttendanceRef.current.setDirty( value ) ;

        if ( value == false )
        {
            if ( props.setDirty != null )
            {
                props.setDirty( value ) ;
            }
        }
    }

    function onSave()
    {
        if ( !formIsValid() )
        {
            setDisplayErrors( true ) ;
        }
        else
        {
            if ( props.onSave != null )
            {
                // Just pass the click back to the creating form
                props.onSave() ;
            }
        }
    }

    function onComplete()
    {
        setMode( props.mode ) ;
    }

    function onClickSave()
    {
        let data = [] ;

        data.push( getFormData()) ;

        let olddata = attendanceData ;

        olddata.attended_days = data[0].attendance.attended_days ;
        olddata.out_of_days = data[0].attendance.out_of_days ;
        olddata.authorised_absences = data[0].attendance.authorised_absences ;
        olddata.unauthorised_absences = data[0].attendance.unauthorised_absences ;
        olddata.reason = data[0].attendance.reason ;

        setAttendanceData( olddata ) ;

        props.saveFunction( props.child_id, data, onComplete ) ;
    }

    function title()
    {
        let title = "Attendance" ;

        if ( props.attendanceData != null && props.attendanceData.description != null )
        {
            let year = +props.attendanceData.year_start ;
            let year_next = year + 1 ;

            let term = props.attendanceData.description ;

            if ( term == 'Autumn' )
            {
                title += ' - ' + term + ' ' + year ;
            }
            else
            {
                title += ' - ' + term + ' ' + year_next ;
            }
        }

        return title ;
    }

    function onClickEdit()
    {
        setMode( 'modify' ) ;
    }

    function onClickCancel()
    {
        setMode( props.mode ) ;
    }

    useImperativeHandle( ref, () => ({
        getFormData,
        formIsValid,
        isDirty,
        setDirty,
        autoSave,
        doSave,
        onLeave,
        onSave
    })) ;

    function panelHeader( headerTitle, allow_edit )
    {
        let disabled = true ;
        let handler = null ;
        let icon = 'glyphicon-pencil' ;
        let style = 'panel-header-control-edit' ;
        let tip = 'Edit this attendance record' ;

        if ( allow_edit == true && ( props.setting != 'progressreview' && props.setting != 'pep' ))
        {
            if ( mode == 'view' || mode == 'qa' )
            {
                handler = onClickEdit ;
                disabled = false ;
            }
            else
            {
                handler = onClickCancel ;
                disabled = false ;
                icon = 'glyphicon-ban-circle' ;
                style = 'panel-header-control-delete' ;
                tip = "Cancel Edit" ;
            }
        }

        return (
            <div className="panel-heading">
                <span>{headerTitle}</span>
                <PanelControlDelete disabled={disabled} tip={tip} onClick={handler} enabledStyle={style} glyphicon={icon}/>
            </div>
        ) ;
    }

    function saveButtonRow()
    {
        return (
            <BootstrapRow style={{marginTop: '10px'}}>
                <BootstrapCol width={9}/>
                <div className="col-md-3">
                    <button id="SaveButton" type="button" className="btn btn-primary" style={{float: 'right'}} onClick={onClickSave}>Save</button>
                    <button id="CancelButton" type="button" className="btn btn-secondary" style={{float: 'right', marginRight: '10px'}}
                            onClick={onClickCancel}>Cancel
                    </button>
                </div>
            </BootstrapRow>
        ) ;
    }

    function p1()
    {
        let allow_edit = true ;
        let childMode = 'view' ;

        if ( mode == 'modify' || props.setting == 'pep' || props.setting == 'progressreview' )
        {
            childMode = 'edit' ;
        }
        else if ( mode == 'qa' )
        {
            childMode = 'view' ;
        }

        if (( mode == 'view' && props.setting == 'child' ) || props.setting == 'pep' || props.setting == 'progressreview' )
        {
            allow_edit = true ;
        }

        return <div className={'panel ' + props.panelStyle}>
            {panelHeader( title(), allow_edit )}
            <div className="panel-body">
                <ChildAttendanceRow ref={formAttendanceRef} tabIndex={props.tabIndex} onDirty={props.onDirty} mode={childMode} reasonRows={props.reasonRows}
                                    attendanceData={attendanceData} displayErrors={displayErrors}/>
                {mode === 'modify' && saveButtonRow()}
            </div>
            <ReactTooltip key="tooltipAttendance" className="tool-class" ref={tooltipAttendanceRef}/>
        </div> ;
    }

    return <div className="">
        {p1()}
        <NavRowComponent navigationNotifier={props.navigationNotifier}
                         prevButtonRequired={props.prevButtonRequired === true}
                         nextButtonRequired={props.nextButtonRequired === true}
                         saveButtonRequired={props.saveButtonRequired === true}
                         cancelButtonRequired={props.cancelButtonRequired === true}
                         formIsValid={formIsValid}
                         setDisplayErrors={setDisplayErrors}/>
    </div> ;
}

const ChildProgressReviewAttendance2WithRef = forwardRef( ChildProgressReviewAttendance2 ) ;

ChildProgressReviewAttendance2WithRef.defaultProps =
    {
        title: 'title',
        panelStyle: 'panel-default panel-subject',
        attendanceData: null,
        reasonRows: 3,
        tabIndex: 0,
        mode: 'view'
    } ;

export default ChildProgressReviewAttendance2WithRef ;